<template>
  <div class="relative">
    <p
      v-if="$feature.sketchfabProductList[productId]"
      class="absolute bottom-0 m-4 flex rounded-xs bg-black p-2 text-sm c-white fw-bold uppercase"
    >
      <base-picture v-bind="icon" :alt="$t.model3d" class="mr-2" />
      {{ $t.model3d }}
    </p>
    <vf-button
      v-if="currentApiState === 'started'"
      class="absolute right-2 top-2 z-1"
      @click="stopAnimation"
    >
      <vf-icon name="close" size="sm" />
    </vf-button>

    <iframe
      v-show="$feature.sketchfabProductList[productId] === hash"
      v-for="(hash, key) in hashes"
      :key
      ref="iframes"
      v-style="{ 'aspect-ratio': { sm: '1/1', md: '16/9' } }"
      allow="autoplay; fullscreen; xr-spatial-tracking"

      allowfullscreen

      class="w-full"

      mozallowfullscreen="true"

      :title="$t.model3d"
      web-share
      webkitallowfullscreen="true"
      xr-spatial-tracking
    />
  </div>
</template>

<script lang="ts" setup>
const { productId } = defineProps<{
  productId: string
}>()

const { autoplay, icon } = useAppConfig().components.sketchfab
const iframes = ref()
const hashes = ref<string[]>([])
const apis: any[] = []
const apiStates = ref<Record<number, string>>({})
const { $t, $feature } = useNuxtApp()

const currentApiState = computed(() => {
  const currentIndex = hashes.value.indexOf($feature.sketchfabProductList[productId])
  return apiStates.value[currentIndex] || 'stopped'
})

watch(() => iframes, () => {
  if (!iframes.value?.length) return

  const apiIndex = iframes.value.length - 1
  const sketchfab = new window.Sketchfab(iframes.value.at(-1))

  apiStates.value[apiIndex] = 'stopped'

  sketchfab.init($feature.sketchfabProductList[productId], {
    ui_controls: 0,
    ui_infos: 0,
    ui_watermark: 0,
    success: (api) => {
      apis.push(api)

      api.addEventListener('viewerstart', () => {
        apiStates.value[apiIndex] = 'started'
      })

      api.addEventListener('viewerready', () => {
        apiStates.value[apiIndex] = 'started'
      })

      api.addEventListener('viewerstop', () => {
        apiStates.value[apiIndex] = 'stopped'
      })

      if (autoplay)
        api.start()
    },
    error: (e: any) => log.error(`Sketchfab: Error initializing viewer:`, e)
  })
}, { deep: true })

const stopAnimation = () => {
  apis.forEach((api, index) => {
    api.stop()
    apiStates.value[index] = 'stopped'
  })
}

const { onLoaded } = useScript({
  async: true,
  integrity: 'sha256-L6xxMyYXO8vGH5p6/VjlsU5jv+qFXczZKPd3oFZ3xGQ=',
  src: 'https://static.sketchfab.com/api/sketchfab-viewer-1.12.1.js'
})

onLoaded(() => {
  watchImmediate(() => productId, () => {
    const hash = $feature.sketchfabProductList[productId]
    const hashIndex = hashes.value.indexOf(hash)

    apis.forEach((api, i) => {
      if (i === hashIndex) {
        if (autoplay) {
          api.start()
          apiStates.value[i] = 'started'
        }
      }
      else {
        api.stop()
        apiStates.value[i] = 'stopped'
      }
    })

    if (!hash) return

    if (hashIndex === -1) hashes.value.push(hash)
  })
})
</script>
